import { render } from "./ChatBox.vue?vue&type=template&id=ced2d5fe"
import script from "./ChatBox.vue?vue&type=script&lang=js"
export * from "./ChatBox.vue?vue&type=script&lang=js"

import "./ChatBox.vue?vue&type=style&index=0&id=ced2d5fe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__